<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> Bank KYC</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row">
            <div class="col-md-12 mb-3">
                <label for="BankId" class="form-font-label">Bank</label>
                <ng-select name="BankId" placeholder="Select Bank" #BankId="ngModel" [(ngModel)]="BankDetail.BankId"
                    (change)="GetIFSCCode()" [disabled]="BankDetail.BankVerificationID==null?false:true" required>
                    <ng-option *ngFor="let Bank of Banks" [value]="Bank.bank_master_id">{{Bank.bank_name}}</ng-option>
                </ng-select>
                <div class="invalid-feedback">
                    Please select bank!
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <div class="input-group">
                    <span class="input-group-text" id="lblAccountNo">Account No</span>
                    <input type="password" class="form-control" placeholder="Account No" aria-label="Account No"
                        id="AccountNoStar" name="AccountNoStar" [(ngModel)]="BankDetail.BankAccountNoStar"
                        #AccountNoStar="ngModel" required aria-describedby="lblAccountNo" pattern="^[0-9]\d*$"
                        [min]="BankDetail.AccountLength"
                        [minlength]="BankDetail.AccountLength"
                        [maxlength]="BankDetail.AccountLength==0?20:BankDetail.AccountLength"
                        (keypress)="common.NumberOnly($event)" [max]="BankDetail.AccountLength"
                        (keydown)="ClearAccountNo()"
                        onpaste="return false"
                        [disabled]="BankDetail.BankVerificationID==null && BankDetail.BankId > 0?false:true">
                    <div class="invalid-feedback">
                        Please enter account no with length of {{BankDetail.AccountLength}}!
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <div class="input-group">
                    <span class="input-group-text" id="lblAccountNo">Confirm Account No</span>
                    <input type="text" class="form-control" placeholder="Account No" aria-label="Account No"
                        id="AccountNo" name="AccountNo" [(ngModel)]="BankDetail.BankAccountNo" #AccountNo="ngModel"
                        required aria-describedby="lblAccountNo" pattern="^[0-9]\d*$"
                        [minlength]="BankDetail.AccountLength"
                        [maxlength]="BankDetail.AccountLength==0?20:BankDetail.AccountLength"
                         maxlength="20" (keypress)="common.NumberOnly($event)"
                        [max]="BankDetail.AccountLength"
                        onpaste="return false"
                        [disabled]="(BankDetail.BankVerificationID==null && BankDetail.BankAccountNoStar != null && BankDetail.BankAccountNoStar != '' && BankDetail.BankId > 0)?false:true">
                    <div class="invalid-feedback">
                        Please enter account no with length of {{BankDetail.AccountLength}}!
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <div class="input-group">
                    <span class="input-group-text" id="lblIFSCCode">IFSC Code</span>
                    <input type="text" class="form-control" placeholder="IFSC Code" aria-label="IFSC Code" id="IFSCCode"
                        name="IFSCCode" [(ngModel)]="BankDetail.IFSCode" #IFSCode="ngModel" minlength="11"
                        maxlength="11" (input) = "common.ToUpperCaseE($event)" required
                        aria-describedby="lblIFSCCode" [disabled]="BankDetail.BankVerificationID==null && BankDetail.BankId > 0?false:true">
                    <div class="invalid-feedback">
                        Please enter valid IFSC code!
                    </div>
                </div>
            </div>
            <div class="col-md-12 m-1" *ngIf="BankDetail.BankVerificationID != null">
                <label style="color:var(--success)">Bank Verified Name</label><br />
                <label>{{BankDetail.NameAsPerBank}}</label>
            </div>
        </div>
        <div class="row m-1">
            <button *ngIf="BankDetail.BankVerificationID == null" type="submit" class="btn btn-primary"
                [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Verify':'Loading...'}}</button>

            <button *ngIf="BankDetail.BankVerificationID != null" type="button" class="btn btn-primary"
                [disabled]="isDisabled" (click)="Confirm()">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Confirm':'Loading...'}}</button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>